import { useState } from "react";
import { optimizeImage } from "../utils/optimizeImage";

// Shows the whole image inside a fixed-ratio placeholder without cropping. When the source ratio
// does not match, a soft blurred copy of the same image fills the gaps so the card still reads as editorial.
const FitImage = ({ src, alt, width = 800, ratio = "aspect-[3/2]", className = "", imgClassName = "" }) => {
  const [fills, setFills] = useState(true);
  const url = optimizeImage(src, { width });
  const onLoad = (e) => {
    const { naturalWidth: w, naturalHeight: h } = e.currentTarget;
    if (w && h) setFills(Math.abs(w / h - 1.5) < 0.04);
  };
  return (
    <div className={`relative overflow-hidden bg-neutral-100 ${ratio} ${className}`}>
      {!fills && (
        <img src={url} alt="" aria-hidden="true" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover blur-xl opacity-70" />
      )}
      <img
        src={url}
        alt={alt}
        loading="lazy"
        decoding="async"
        onLoad={onLoad}
        className={`absolute inset-0 w-full h-full ${fills ? "object-cover" : "object-contain"} ${imgClassName}`}
      />
    </div>
  );
};

export default FitImage;
